// action types
export const SELECT_PROGRAM = "selectProgram";
export const UNSELECT_PROGRAM = "unselectProgram";
export const ENABLE_COMING_SOON_BYPASS_ACTION = "enableComingSoonBypass";
export const DISABLE_COMING_SOON_BYPASS_ACTION = "disableComingSoonBypass";

// mutation types
export const SET_PROGRAM = "setProgram";
export const ENABLE_COMING_SOON_BYPASS = "enableComingSoonBypass";
export const DISABLE_COMING_SOON_BYPASS = "disableComingSoonBypass";

export default {
  state: {
    program: null,
    byPassComingSoonPages: false
  },
  getters: {
    /**
     * Get current selected program
     * @param state
     * @returns {*}
     */
    selectedProgram(state) {
      return state.program;
    },
    byPassComingSoonPages(state) {
      return state.byPassComingSoonPages;
    }
  },
  actions: {
    /**
     * Select program
     * @param state
     * @param payload
     */
    [SELECT_PROGRAM](state, payload) {
      state.commit(SET_PROGRAM, payload);
    },

    /**
     * Unselect program
     * @param state
     * @param payload
     */
    [UNSELECT_PROGRAM](state) {
      state.commit(SET_PROGRAM, null);
    },
    [ENABLE_COMING_SOON_BYPASS_ACTION]({ commit }) {
      commit(ENABLE_COMING_SOON_BYPASS);
    },
    [DISABLE_COMING_SOON_BYPASS_ACTION]({ commit }) {
      commit(DISABLE_COMING_SOON_BYPASS);
    }
  },
  mutations: {
    [SET_PROGRAM](state, payload) {
      state.program = payload;
    },
    [ENABLE_COMING_SOON_BYPASS](state) {
      state.byPassComingSoonPages = true;
    },
    [DISABLE_COMING_SOON_BYPASS](state) {
      state.byPassComingSoonPages = false;
    }
  }
};
